exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".quiz-form .padding {\n  padding-top: 3.125rem;\n  padding-left: 0.625rem; }\n\n.quiz-form .text-right {\n  text-align: right; }\n\n.quiz-form input,\n.quiz-form label {\n  margin: 0.75rem 0 1.25rem 0; }\n\n.quiz-form label {\n  padding-left: 0.375rem;\n  padding-right: 0.75rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/quiz/quiz-form/quiz-form.component.scss
// module id = 2075
// module chunks = 66